import type { ReactNode } from "react"
import { createContext, useContext } from "react"

const TemplateInfoAdvisorContext = createContext<{
  templateCountryCode: string | null | undefined
  companyCurrencyCode: string | null | undefined
}>({
  templateCountryCode: null,
  companyCurrencyCode: null,
})

export const useTemplateInfoAdvisor = () => {
  return useContext(TemplateInfoAdvisorContext)
}

export const TemplateInfoAdvisorProvider = ({
  children,
  templateCountryCode,
  companyCurrencyCode,
}: {
  children: ReactNode
  templateCountryCode: string | null | undefined
  companyCurrencyCode: string | null | undefined
}) => {
  return (
    <TemplateInfoAdvisorContext.Provider
      value={{
        templateCountryCode,
        companyCurrencyCode,
      }}
    >
      {children}
    </TemplateInfoAdvisorContext.Provider>
  )
}
